const getFilterToggleId = (filterItem) => {
  return `dropdown-toggle-${filterItem.label}-${filterItem.key}`;
}

const createFilter = (key, label, value, type) => {
  const newFilter = { key, label, value, type };
  setTimeout(() => {
    const toggleId = filterUtils.getFilterToggleId(newFilter);
    const toggle = document.getElementById(toggleId);
    if (toggle) {
      toggle.click();
    }
  }, 100);
  return newFilter;
};

const filterUtils = {
  getFilterToggleId,
  createFilter
};

export default filterUtils;
